import { environment } from "src/environments/environment";
import { Location } from "@angular/common";

export class Webflow {
  static myAction(router, actionName: string, params: any) {
    if (Webflow.isIFrame()) {
      let myLink = environment.webflow_url + "/app?action=" + actionName;
      if (params != undefined) {
        Object.entries(params).forEach(([key, value]) => {
          myLink += "&" + key + "=" + value;
        });
      }
      window.top.location.href = myLink;
    } else {
      router
        .navigateByUrl("/", { skipLocationChange: false })
        .then(() =>
          router.navigate(["/" + actionName], { queryParams: params })
        );
    }
  }

  static isIFrame() {
    return (
      typeof window !== "undefined" &&
      typeof parent !== "undefined" &&
      window != parent
    );
  }

  static setIFrameHeight(
    scrolToTop: boolean = true,
    custom_height: number = 0
  ) {
    if (this.isIFrame()) {
      setTimeout(() => {
        const elementHeight = document.body.scrollHeight + custom_height;
        const currentUser = JSON.parse(localStorage.getItem("studiomapUser")!);
        parent.postMessage(
          JSON.stringify({
            userData: currentUser,
            userDesconnect: currentUser == null,
            iframeHeight: elementHeight,
            scrolToTop: scrolToTop,
          }),
          environment.webflow_url
        );
      }, 200);
    }
  }

  static scrollToElementById(elementId: string) {
    if (this.isIFrame()) {
      setTimeout(() => {
        const elementHeight = document.body.scrollHeight;
        parent.postMessage(
          JSON.stringify({
            iframeHeight: elementHeight,
            scrollToElementId: elementId,
          }),
          environment.webflow_url
        );
      }, 200);
    } else {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        console.warn(`Element with ID '${elementId}' not found.`);
      }
    }
  }
}
